import React, { useState, useEffect } from "react";
import { getProductClassL } from "../../../http/api/ProductClassLAPI";
import { Select, MenuItem, FormControl } from "@mui/material";

const ProductClassLSelect = ({ onChange, value }) => {
  const [listProductClassL, setListProductClassL] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || "-1");

  async function getListProductClassL() {
    let response = await getProductClassL({});
    setListProductClassL(response.listProductClassLInfo);
  }

  useEffect(() => { 
    getListProductClassL();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400, marginInline: 1 }}
      >
        <MenuItem key="unselected" value="-1">
          [未選択]
        </MenuItem>
        {listProductClassL.map((item) => (
          <MenuItem key={item.productClassLId} value={item.productClassLId}>
            {item.productClassLName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default ProductClassLSelect;
